<template>
    <div ref="info" class="bill-recive-tips">
        <img :src="infoImg" alt="" @mouseenter="mouseIn" @mouseout="mouseOut">
        <div  v-if="tipStatus.tip" class="info">
           <div>
               <span class="title">
                   1. 系統預設收費租期：
               </span>
               <span class="content">
                   使用情境：系統會依照合約，自動產生計費期間選單，若滿足您的需求可以使用此模式，更便捷的幫助您收租。
               </span>
           </div>
           <div>
               <span class="title">
                   2.自訂收費日：
               </span>
               <span class="content">
                   使用情境：若系統預設計費期間不符您的需求，您可以使用此模式，自訂『收費日』和『自訂計費期間』，更彈性的向租客收費，例如合約設定每月1號繳租，房客在2/15號入住。您可以使用此模式，建立收費日：2/15，計費期間：2/15~2/28的帳單。
               </span>
           </div>
        </div>
        <!-- <border-tips v-if="tipStatus.tip" msg="報價說明文案報價說明文案報價說明文案。" width="117px"></border-tips> -->
    </div>
</template>

<script>
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
export default {
    data () {
        return {
            show: 0,
            infoImg: require('@/assets/img/icon/info_gray.svg'),
            tipStatus: {
                tip: false,
            },
        }
    },
    methods: {
        mouseIn: function () {
            this.infoImg = require('@/assets/img/icon/info_blue.svg')
            this.tipStatus.tip = true
            this.$refs.info.style.zIndex = 2
        },
        mouseOut: function () {
            this.infoImg = require('@/assets/img/icon/info_gray.svg')
            this.tipStatus.tip = false
            this.$refs.info.style.zIndex = 1

        },
    },
    components: {
        borderTips
    }
}
</script>
<style lang="scss"  >
    .bill-recive-tips{
        position: absolute;
        top: 4px;
        right: -24px;
        z-index: 1;
        font-size: 14px;
        color: #292625;
        .info{
            position: absolute;
            left: 20px;
            top: 0px;
            box-shadow: 1px 3px 8px 0 rgba(3, 6, 52, 0.08);
            border: solid 1px #3942b5;
            background-color: #ffffff;
            padding: 11px 16px;
            border-radius: 4px;
            width: 384px;
            box-sizing: border-box;
            line-height: 1.7;
            .title{
                color: #3942b5;
            }
            >div{
                margin-bottom: 12px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tips/billReciveTipsHover.vue